import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@mui/material';

import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { getAddress, selectVehicleById } from '../../features/assets/assetsSlice';
import AddressCard from './AddressCard';

const AddressModal = ({ addressOpen, handleAddressClose, assetId }) => {
    const dimention = useSelector(liveTrackinglayoutSelector);
    const dispatch = useDispatch();
    const assetData = useSelector(state => selectVehicleById(state, assetId));
    const address = assetData && assetData.address;
    const regn = assetData && assetData.vehicleDevice.regn;

    useEffect(() => {
        if (!address && addressOpen && assetData && assetData.coreData) {
            dispatch(getAddress({
                assetId,
                lat: assetData.coreData.lat,
                lng: assetData.coreData.lng,
            }))
        }
    }, [assetId, addressOpen, address, assetData, dispatch])

    return (
        <Modal
            open={addressOpen}
            onClose={handleAddressClose}
        >
            <div style={dimention.mapModal}>
                <AddressCard address={address} title={`Address: ${regn}`} />
            </div>
        </Modal>
    );
}

export default AddressModal;

